//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'BMI',
  data() {
    return {
      form: {
        height: '',
        weight: ''
      },
      hasScore: false,
      disabled: false,
      descTxt: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
      } else {
        console.log(form)
        let result = form.weight / (form.height * form.height)
        if (result < 18.5) {
          self.descTxt = '体重过低'
        } else if (result >= 18.5 && result <= 24.0) {
          self.descTxt = '正常范围'
        } else if (result >= 24.0) {
          self.descTxt = '超重'
        } else if (result >= 28.0) {
          self.descTxt = '肥胖'
        }
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/BMI.vue